/* unplugin-vue-components disabled */import { render } from "./recommendCourse.vue?vue&type=template&id=2168ef64&scoped=true"
import script from "./recommendCourse.vue?vue&type=script&lang=js"
export * from "./recommendCourse.vue?vue&type=script&lang=js"

import "./recommendCourse.vue?vue&type=style&index=0&id=2168ef64&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户哈尔滨医科大学-前端页面-saas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2168ef64"]])

export default __exports__